const state = {
  clubs: [
    {
      name: 'KuntoKruunu Klaukkala',
      id: 1,
      location: 'Klaukkala',
      queryName: 'klaukkala',
      genetive: 'Klaukkalan',
      partitive: 'KuntoKruunu Klaukkalaa',
      imageUrl:
        'https://www.kuntokruunu.fi/wp-content/uploads/2025/01/klaukkala-kokeilu.jpg',
      clubLevel: 3,
      services: [
        {
          name: 'Kuntosali',
          id: 1,
        },
      ],
      whatYouGet: 'Klaukkalan kuntosalia',
      hours: [
        'Ma klo 16-18',
        'Ti klo 9-12',
        'Ke klo 16-18 virtuaalivastaanotto',
        'Muina aikoina erikseen sovitusti',
      ],
      contact: {
        email: 'klaukkala@kuntokruunu.fi',
        phone: '+358406481199',
        phone_pretty: '040 648 1199',
      },
      mautic: {
        tag: 'kokeilupassi-klaukkala',
        segmentID: 4,
        campaignID: 4,
      },
      buttons: [
        {
          text: 'KuntoKruunun etusivu',
          blank: false,
          link: 'https://www.kuntokruunu.fi',
          featured: true,
          iconClass: 'bxs-home',
        },
        {
          text: 'Katso sijainti kartalta',
          blank: true,
          link:
            'https://www.google.com/maps/place/KuntoKruunu+Klaukkala/@60.3886384,24.7363608,15z/data=!4m5!3m4!1s0x0:0xf8a8de3aa3972194!8m2!3d60.3886384!4d24.7363608',
          featured: false,
          iconClass: 'bxs-navigation',
        },
      ],
      errorBtn: {
        text: 'Asiakkuudet',
        blank: false,
        link:
          'https://www.kuntokruunu.fi/kauppa/?filter_kuntosali=klaukkala&query_type_kuntosali=and',
        featured: true,
        iconClass: 'bxs-id-card',
      },
      shares: {
        facebook:
          'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fkokeile.kuntokruunu.fi',
        messenger:
          'fb-messenger://share/?link=https%3A%2F%2Fkokeile.kuntokruunu.fi',
        whatsapp:
          'whatsapp://send?text=Moi%21%0A%0AT%C3%A4m%C3%A4n%20passin%20avulla%20p%C3%A4%C3%A4set%20kokeilemaan%20KuntoKruunua%20ilmaiseksi%21%20Lataa%20passi%20s%C3%A4hk%C3%B6postiisi%20t%C3%A4%C3%A4lt%C3%A4%3A%20https%3A%2F%2Fkokeile.kuntokruunu.fi%0A%0AKuntoKruunulla%20on%20salit%20Klaukkalassa%20ja%20Nurmij%C3%A4rvell%C3%A4.%20Tutustu%20KuntoKruunuun%20tarkemmin%3A%20https%3A%2F%2Fwww.kuntokruunu.fi',
        email:
          'mailto:?subject=KuntoKruunun%20ilmainen%20kokeilu%21&body=Moi%21%0A%0AT%C3%A4m%C3%A4n%20passin%20avulla%20p%C3%A4%C3%A4set%20kokeilemaan%20KuntoKruunua%20ilmaiseksi%21%20Lataa%20passi%20s%C3%A4hk%C3%B6postiisi%20t%C3%A4%C3%A4lt%C3%A4%3A%20https%3A%2F%2Fkokeile.kuntokruunu.fi%0A%0AKuntoKruunulla%20on%20salit%20Klaukkalassa%20ja%20Nurmij%C3%A4rvell%C3%A4.%20Tutustu%20KuntoKruunuun%20tarkemmin%3A%20https%3A%2F%2Fwww.kuntokruunu.fi',
      },
    },
    {
      name: 'KuntoKruunu Nurmijärvi',
      id: 2,
      location: 'Nurmijärvi',
      queryName: 'nurmijarvi',
      genetive: 'Nurmijärven',
      partitive: 'KuntoKruunu Nurmijärveä',
      imageUrl:
        'https://www.kuntokruunu.fi/wp-content/uploads/2020/09/nurmijarvi_passi_kuva.jpg',
      clubLevel: 2,
      services: [
        {
          name: 'Kuntosali',
          id: 1,
        },
      ],
      whatYouGet: 'Nurmijärven kuntosalia',
      hours: [
        'Ma klo 16-18 virtuaalivastaanotto',
        'Ti klo 9-12 virtuaalivastaanotto',
        'Ke klo 16-18 virtuaalivastaanotto',
        'Muina aikoina erikseen sovitusti',
      ],
      contact: {
        email: 'nurmijarvi@kuntokruunu.fi',
        phone: '+358406481199',
        phone_pretty: '040 648 1199',
      },
      virtual_reception: true,
      mautic: {
        tag: 'kokeilupassi-nurmijarvi',
        segmentID: 5,
        campaignID: 5,
      },
      buttons: [
        {
          text: 'KuntoKruunun etusivu',
          blank: false,
          link: 'https://www.kuntokruunu.fi',
          featured: true,
          iconClass: 'bxs-home',
        },
        {
          text: 'Katso sijainti kartalta',
          blank: true,
          link:
            'https://www.google.com/maps/place/KuntoKruunu+Nurmij%C3%A4rvi/@60.4592521,24.82832,15z/data=!4m5!3m4!1s0x0:0x9de7ca14512e753!8m2!3d60.4592521!4d24.82832',
          featured: false,
          iconClass: 'bxs-navigation',
        },
      ],
      errorBtn: {
        text: 'Asiakkuudet',
        blank: false,
        link:
          'https://www.kuntokruunu.fi/kauppa/?filter_kuntosali=nurmijarvi&query_type_kuntosali=and',
        featured: true,
        iconClass: 'bxs-id-card',
      },
      shares: {
        facebook:
          'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fkokeile.kuntokruunu.fi',
        messenger:
          'fb-messenger://share/?link=https%3A%2F%2Fkokeile.kuntokruunu.fi',
        whatsapp:
          'whatsapp://send?text=Moi%21%0A%0AT%C3%A4m%C3%A4n%20passin%20avulla%20p%C3%A4%C3%A4set%20kokeilemaan%20KuntoKruunua%20ilmaiseksi%21%20Lataa%20passi%20s%C3%A4hk%C3%B6postiisi%20t%C3%A4%C3%A4lt%C3%A4%3A%20https%3A%2F%2Fkokeile.kuntokruunu.fi%0A%0AKuntoKruunulla%20on%20salit%20Klaukkalassa%20ja%20Nurmij%C3%A4rvell%C3%A4.%20Tutustu%20KuntoKruunuun%20tarkemmin%3A%20https%3A%2F%2Fwww.kuntokruunu.fi',
        email:
          'mailto:?subject=KuntoKruunun%20ilmainen%20kokeilu%21&body=Moi%21%0A%0AT%C3%A4m%C3%A4n%20passin%20avulla%20p%C3%A4%C3%A4set%20kokeilemaan%20KuntoKruunua%20ilmaiseksi%21%20Lataa%20passi%20s%C3%A4hk%C3%B6postiisi%20t%C3%A4%C3%A4lt%C3%A4%3A%20https%3A%2F%2Fkokeile.kuntokruunu.fi%0A%0AKuntoKruunulla%20on%20salit%20Klaukkalassa%20ja%20Nurmij%C3%A4rvell%C3%A4.%20Tutustu%20KuntoKruunuun%20tarkemmin%3A%20https%3A%2F%2Fwww.kuntokruunu.fi',
      },
    },
  ],
  selectedClub: {},
  hasSelected: false,
}

const getters = {
  allClubs: state => state.clubs,
  getSelectedClub: state => state.selectedClub,
  hasSelectedClub: state => state.hasSelected
};

const actions = {
  selectClub({ commit }, id) {
    commit("setSelectedClub", id);
  },
  selectClubByQueryName({ commit }, queryName) {
    commit("setSelectedClubByQueryName", queryName);
  }
};

const mutations = {
  setSelectedClub: (state, id) => {
    const index = state.clubs.findIndex(club => club.id === id);
    if (index !== -1) {
      state.selectedClub = state.clubs[index];
      state.hasSelected = true;
    }
  },
  setSelectedClubByQueryName: (state, queryName) => {
    const index = state.clubs.findIndex(club => club.queryName === queryName);
    if (index !== -1) {
      state.selectedClub = state.clubs[index];
      state.hasSelected = true;
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
